import React, { useEffect } from "react";
import { useSelector } from "react-redux";
//console.log("src/components/Header.js");

function Example(f1, f2) {
  useEffect(() => {
    document.title = `${f1} - ${f2}`;
  });
}

const Header = () => {
  const init = useSelector((state) => state.init);
  return (
    <header>
      <div>
        <img src={init.c2} alt={init.c1} title={init.c1} />
      </div>
      {/* <div>
        C: {c}
        <br />
        L: {l}
        <br />
        O: {o}
        <br />
        B: {b}
        <br />
        S: {s}
        <br />
      </div> */}
      {Example(init.title, init.c1)}
    </header>
  );
};

export default Header;
